module.exports = __webpack_public_path__ + "static/1 (2)-32096d4fc78e2e533fa2c37eef705c95.png";